import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { PreviewButton } from "../previewButton/PreviewButton";
import { Button } from "../../../../components/button/Button";
import { FormSubmitButton } from "../../../../components/form";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";

import "./TabControls.scss";

export const TabControls = ({
  isFormValid,
  isFormUnchanged,
  onReset,
  onPreview,
  className,
}) => (
  <div className={classnames(className, "tab-controls")}>
    <NotMobile>
      <PreviewButton onClick={onPreview} disabled={!isFormValid} />
      <div className={"tab-controls__saving-buttons"}>
        <Button
          color={"secondary"}
          size={"large"}
          onClick={onReset}
          disabled={isFormUnchanged}
        >
          <FormattedMessage id={"discard"} />
        </Button>
        <FormSubmitButton
          label={<FormattedMessage id={"save_changes"} />}
          disabled={isFormUnchanged || !isFormValid}
        />
      </div>
    </NotMobile>
    <Mobile>
      <div className={"tab-controls__saving-buttons"}>
        <Button
          color={"secondary"}
          size={"large"}
          onClick={onReset}
          disabled={isFormUnchanged}
        >
          <FormattedMessage id={"discard"} />
        </Button>
        <PreviewButton onClick={onPreview} disabled={!isFormValid} />
        <FormSubmitButton
          label={<FormattedMessage id={"save"} />}
          disabled={isFormUnchanged || !isFormValid}
        />
      </div>
    </Mobile>
  </div>
);
